export function prepareQuery(location) {
  let placesQuery = location.name;

  if (location.address) {
    placesQuery = `${placesQuery} ${location.address},`;
  }

  if (location.city && location.state) {
    placesQuery = `${placesQuery} ${location.city}, ${location.state.name}`;
  }

  if (location.zipcode) {
    // Check for any zipcodes with long formatting.
    let locationZipcode = location.zipcode.trim();
    if (locationZipcode.includes("-")) {
      locationZipcode = locationZipcode.split("-")[0];
    }
    placesQuery = `${placesQuery} ${locationZipcode}`;
  }

  return placesQuery;
}
export function parseAddress(addressComponents) {
  let result = {
    address_line_1: '',
    address_line_2: '',
    city: '',
    county: '',
    state: '',
    postal_code: '',
    country: ''
  };

  addressComponents.forEach(component => {
    switch (component.types[0]) {
      case 'street_number':
        result.address_line_1 = component.long_name + ' ';
        break;
      case 'route':
        result.address_line_1 += component.long_name;
        break;
      case 'subpremise':
      case 'premise':
        result.address_line_2 = component.long_name;
        break;
      case 'neighborhood':
      case 'locality':
        result.city = component.long_name;
        break;
      case 'administrative_area_level_3':
        if(!result.city) {
          result.city = component.long_name;
        }
        break;
      case 'administrative_area_level_2':
        result.county = component.long_name;
        break;
      case 'administrative_area_level_1':
        result.state = component.short_name;
        break;
      case 'postal_code':
        result.postal_code = component.long_name;
        break;
      case 'country':
        result.country = component.long_name;
        break;
      default:
        console.log(`Found type: ${component.types[0]} not used`);
    }
  });

  if (result.country === 'Canada' && !result.city) {
    result.city = result.county;
  }

  return result;
}